// extracted by mini-css-extract-plugin
export default {"heading":"AddBlog_heading__aQNPG"};